module.exports = __webpack_public_path__ + "media/images/icons/map/marker-current-94ee1dc7bd83bbd2328128c2c4ddef15.png";